import {AbstractThreshold, PinedThresholdValue} from "../basic/threshold";

export class ThresholdImage extends AbstractThreshold {
  constructor(options?: {
    threshold: number
  }) {
    super(new PinedThresholdValue(options?.threshold));
  }

}


